import React from "react";
import { ApplyTemplateToProps } from "../ApplyTemplateDropdown/index.types";
import { cls } from "app/utils";
import { useStoreActions } from "app/utils/hooks";
import { fetchTeams } from "app/actions/team";

const ApplyTemplateToGroup = ({
  className,
  groupSelectModalHanlder,
}: ApplyTemplateToProps) => {
  useStoreActions({
    team: () => fetchTeams({ "options[include]": ["team_groups"] }),
  });

  return (
    <>
      <div className={cls(className)} onClick={groupSelectModalHanlder}>
        <i className="ico ico-team" />
        <p>Apply to Group</p>
      </div>
    </>
  );
};

export default ApplyTemplateToGroup;
